module.exports = __webpack_public_path__ + "img/434343_9E9E9E_8C8C8C_848484-256px.e749273b.png";